// toast
import { toast, Slide } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import React from "react";
import config from "../const/config";
import companyType from "../types/companyType";
import { Redirect, useHistory } from "react-router-dom";
import qs from "query-string";
import {
  nationStrType,
  nationType,
  tradeMarkCountryKr,
  tradeMarkNationKr,
  tradeMarkNationType,
} from "../types/nationType";
import axios from "axios";
import links from "../const/links";
import GwAPI from "../API/groupware";
import tradeMark from "../store/TradeMark";
import * as Clipboard from "clipboard-polyfill";
import { ClipboardItem } from "clipboard-polyfill";
import CommonAPI from "../API/common";
import { convertInventionStateToStr as convertInventionStateLabel } from "../constants/inventionState";
import { getWorkingCompanyHeaders } from "./workingCompany";
import { money2, sanitizeFloatDisplay } from "./money";

/** 특사 asset 요청용 x-company-idx (admin 경로 제외) */
function applyWorkingCompanyXhrHeaders(req, url = "") {
  const path = String(url || "");
  if (path.includes("/admin/") || path.startsWith("admin/")) return;
  const headers = getWorkingCompanyHeaders();
  Object.keys(headers).forEach((key) => {
    if (headers[key] != null && headers[key] !== "") {
      req.setRequestHeader(key, headers[key]);
    }
  });
}

let { kakao } = window;

export const kr_index = [
  "가",
  "나",
  "다",
  "라",
  "마",
  "바",
  "사",
  "아",
  "자",
  "차",
  "카",
  "타",
  "파",
  "하",
];

export default {
  getGroupwareAdminMenu(setAdminMenu, bean) {
    let param = {
      su_menu_cd: bean.su_menu_cd,
      menu_cd: bean.menu_cd,
    };
    let resultVal = [];
    GwAPI.getAdminMenuList(param).then((res) => {
      let resultData = res.data.dataMenuMap;
      let result = resultData.menuList;
      let resultItems = [];
      if (result.length > 0) {
        // 1단계: lookup 객체 생성
        let lookup = {};
        let defaultItem = {
          name: bean.menuTitle,
          isOpen: bean.isOpen,
          children: [],
          suMenuCd: param.su_menu_cd,
        };
        resultItems = [defaultItem];
        result.forEach((item) => {
          lookup[item.menu_cd] = { ...item }; // item 복사
          lookup[item.menu_cd].name = item.menu_name;
          lookup[item.menu_cd].url = item.link_path;
          lookup[item.menu_cd].isOpen = bean.isOpen;
          lookup[item.menu_cd].isContentWrap = bean.isContentWrap;
          lookup[item.menu_cd].suMenuCd = param.su_menu_cd;
          lookup[item.menu_cd].menuTitle = bean.menuTitle;
        });

        // 2단계: 부모-자식 관계 만들기
        let rootItems = [];
        result.forEach((item) => {
          if (item.su_menu_cd in lookup) {
            // 부모 노드가 있으면, 자식 배열에 추가합니다.
            if (lookup[item.su_menu_cd].children === undefined) {
              lookup[item.su_menu_cd].children = [];
            }
            lookup[item.su_menu_cd].children.push(lookup[item.menu_cd]);
          } else {
            // 부모 노드가 없으면, 루트 노드입니다.
            rootItems.push(lookup[item.menu_cd]);
            resultItems[0].children.push(lookup[item.menu_cd]);
          }
        });

        resultVal = resultItems;
        setAdminMenu(resultItems);
      }
    });
  },
  getGroupwareMenu(setGwMenu, bean) {
    let param = {
      su_menu_cd: bean.su_menu_cd,
    };
    let resultVal = [];
    GwAPI.getMenuList(param).then((res) => {
      let resultData = res.data.dataMenuMap;
      let result = resultData.menuList;
      let resultItems = [];
      if (result.length > 0) {
        // 1단계: lookup 객체 생성
        let lookup = {};
        let defaultItem = {
          name: bean.menuTitle,
          isOpen: bean.isOpen,
          children: [],
          suMenuCd: param.su_menu_cd,
        };
        resultItems = [defaultItem];
        result.forEach((item) => {
          lookup[item.menu_cd] = { ...item }; // item 복사
          lookup[item.menu_cd].name = item.menu_name;
          lookup[item.menu_cd].url = item.link_path;
          lookup[item.menu_cd].isOpen = bean.isOpen;
          lookup[item.menu_cd].isContentWrap = bean.isContentWrap;
          lookup[item.menu_cd].suMenuCd = param.su_menu_cd;
          lookup[item.menu_cd].menuTitle = bean.menuTitle;
        });

        // 2단계: 부모-자식 관계 만들기
        let rootItems = [];
        result.forEach((item) => {
          if (item.su_menu_cd in lookup) {
            // 부모 노드가 있으면, 자식 배열에 추가합니다.
            if (lookup[item.su_menu_cd].children === undefined) {
              lookup[item.su_menu_cd].children = [];
            }
            lookup[item.su_menu_cd].children.push(lookup[item.menu_cd]);
          } else {
            // 부모 노드가 없으면, 루트 노드입니다.
            rootItems.push(lookup[item.menu_cd]);
            resultItems[0].children.push(lookup[item.menu_cd]);
          }
        });

        resultVal = resultItems;
        setGwMenu(resultItems);
      }
    });
  },
  getGroupwareSrcPath(command, docType = "", section = "attend") {
    window.parent.location.href =
      "/groupware/works?section=" +
      section +
      "&command=" +
      command +
      "&doc_type=" +
      docType;
    // if(path === 'attend'){
    //   window.parent.location.href = path + "?doc_type=" + docType;
    // }else if(path === 'vacation'){
    //   path = 'works';
    //   window.parent.location.href = path + "?mode=vacation&doc_type=" + docType;
    // }else{
    //   window.parent.location.href = path;
    // }
  },
  docView(item, lstType) {
    let strParam = "";
    let listMode = "";
    let path = "/groupware/works?section=docView&command=viewDoc";
    strParam += "&idx=" + item.idx;
    strParam += "&doc_knd=" + item.table_name;
    strParam += "&doc_status=" + item.status;
    strParam += "&doc_status_name=" + item.status_name;
    if (lstType == "myList") {
      listMode = "myList";
    }
    strParam += "&list_mode=" + listMode;
    if (item.table_name == "dt_document_worktime") {
      strParam += "&lstPart=doc";
    } else {
      strParam += "&lstPart=" + item.lstPart;
    }
    //alert(strParam);
    window.parent.location.href = path + strParam;
  },
  commandView(item, lstType) {
    let strParam = "";
    let listMode = "";
    let path = "/groupware/works?section=command&command=showCommandOrder";
    strParam += "&idx=" + item.idx;
    strParam += "&method=" + lstType;
    //alert(strParam);
    window.parent.location.href = path + strParam;
  },
  schedulerView(item, lstType) {
    let strParam = "";
    let listMode = "";
    let path = "/groupware/schedule";
    strParam += "?id=" + item.scheduleId;
    window.parent.location.href = path + strParam;
  },
  boardView(item, lstType) {
    let strParam = "";
    let listMode = "";
    let path = "/groupware/works?section=board&command=view";
    strParam += "&boardno=101&pid=" + item.pid;
    window.parent.location.href = path + strParam;
  },

  getCDN(url) {
    return url
      ? url.indexOf("http") > -1
        ? url
        : `https://d1k4pifav5a1we.cloudfront.net/${url}`
      // : require("../assets/images/common/img_news.png").default;
      : require("../assets/images/common/logo_ipnow.svg").default;
  },

  redirectHome(auth) {
    if (auth > -1) {
      window.location.href = "/";
    } else {
      window.location.href = "/intro/main";
    }
  },

  convertDate(date, defaultValue) {
    const fallback = defaultValue || "";
    if (date === null || date === undefined || date === "" || date === 0) {
      return fallback;
    }

    let ts;
    if (date instanceof Date) {
      ts = date.getTime();
    } else if (typeof date === "string" && /^\d{4}-\d{2}-\d{2}/.test(date)) {
      ts = new Date(date).getTime();
    } else {
      ts = Number(date);
      // 초 단위 타임스탬프면 ms로 변환
      if (Number.isFinite(ts) && ts > 0 && ts < 1e11) ts *= 1000;
    }

    if (!Number.isFinite(ts) || ts <= 0) return fallback;

    const parsed = new Date(ts);
    if (Number.isNaN(parsed.getTime())) return fallback;

    const year = parsed.getFullYear();
    // 비정상 과거/미래 값(음수 ts 등) 방어
    if (year < 1970 || year > 2100) return fallback;

    return (
      year +
      "-" +
      (parsed.getMonth() + 1).toString().padStart(2, "0") +
      "-" +
      parsed.getDate().toString().padStart(2, "0")
    );
  },

  convertCommaWithPipe(str) {
    if (!str) {
      return str; // 빈 문자열, null 또는 undefined인 경우 그대로 반환
    }

    if (typeof str !== "string") {
      throw new Error("입력값은 문자열이어야 합니다.");
    }

    return str.replace(/,/g, " | ");
  },

  convertDateUseNA(date, defaultValue) {
    if (!date) return defaultValue || "N/A";
    date = new Date(Number(date));
    return (
      date.getFullYear() +
      "-" +
      (date.getMonth() + 1).toString().padStart(2, "0") +
      "-" +
      date.getDate().toString().padStart(2, "0")
    );
  },

  convertDateNotChar(date, defaultValue) {
    if (!date) return defaultValue || "";
    date = new Date(Number(date));
    return (
      date.getFullYear() +
      (date.getMonth() + 1).toString().padStart(2, "0") +
      date.getDate().toString().padStart(2, "0")
    );
  },

  convertDateKor(date, defaultValue) {
    if (!date) return defaultValue || "N/A";
    date = new Date(Number(date));
    return (
      date.getFullYear() +
      "년 " +
      (date.getMonth() + 1).toString().padStart(2, "0") +
      "월 " +
      date.getDate().toString().padStart(2, "0") +
      "일"
    );
  },

  convertDateDot(date, defaultValue) {
    if (!date) return defaultValue || "N/A";
    date = new Date(Number(date));
    return (
      date.getFullYear() +
      "." +
      (date.getMonth() + 1).toString().padStart(2, "0") +
      "." +
      date.getDate().toString().padStart(2, "0")
    );
  },

  convertMonthDot(date, defaultValue) {
    if (!date) return defaultValue || "N/A";
    date = new Date(Number(date));
    return (
      date.getFullYear() +
      "." +
      (date.getMonth() + 1).toString().padStart(2, "0")
    );
  },
  convertDateTime(date) {
    if (!date) return "N/A";
    date = new Date(Number(date));
    return (
      date.getFullYear() +
      "-" +
      (date.getMonth() + 1).toString().padStart(2, "0") +
      "-" +
      date.getDate().toString().padStart(2, "0") +
      " " +
      date.getHours().toString().padStart(2, "0") +
      ":" +
      date.getMinutes().toString().padStart(2, "0")
    );
  },
  convertDateTimeSlash(date) {
    if (!date) return "N/A";
    date = new Date(Number(date));
    return (
      (date.getMonth() + 1).toString().padStart(2, "0") +
      "/" +
      date.getDate().toString().padStart(2, "0") +
      " " +
      date.getHours().toString().padStart(2, "0") +
      ":" +
      date.getMinutes().toString().padStart(2, "0")
    );
  },
  convertDateTimeSecond(date) {
    if (!date) return "N/A";
    date = new Date(Number(date));
    return (
      date.getFullYear() +
      "-" +
      (date.getMonth() + 1).toString().padStart(2, "0") +
      "-" +
      date.getDate().toString().padStart(2, "0") +
      " " +
      date.getHours().toString().padStart(2, "0") +
      ":" +
      date.getMinutes().toString().padStart(2, "0") +
      ":" +
      date.getSeconds().toString().padStart(2, "0")
    );
  },

  covertLocalDateTime(date) {
    if (!date) return "N/A";
    date = new Date(date);
    return `${date.getFullYear()}-${`${date.getMonth() + 1}`.padStart(
      2,
      "0"
    )}-${`${date.getDate()}`.padStart(2, "0")}T${`${date.getHours()}`.padStart(
      2,
      "0"
    )}:${`${date.getMinutes()}`.padStart(2, "0")}`;
  },

  /*존속기간만료일을 계산하는 함수
  존속기간 만료일은 등록일의 + 10년, 갱신등록시 추가로 + 10년입니다.*/
  convertRegistAtPlusDate(date, length) {
    if (!date) return "N/A";

    date = new Date(date);

    if (length === 0) {
      date.setFullYear(date.getFullYear() + 10);
    } else {
      /*date.setFullYear(date.getFullYear() + 10 * (length + 1));  갱신등록시 추가로 + 10년*/
      date.setFullYear(date.getFullYear() + 10);
    }

    return (
      date.getFullYear() +
      "-" +
      (date.getMonth() + 1).toString().padStart(2, "0") +
      "-" +
      date.getDate().toString().padStart(2, "0")
    );
  },
  isEmptyObject(param) {
    return Object.keys(param).length === 0 && param.constructor === Object;
  },

  convertTypeToText(type) {
    let str = "";
    switch (type) {
      case 0:
        str = "원출원";
        break;
      case 1:
        str = "분할";
        break;
      case 2:
        str = "변경";
        break;
      case 3:
        str = "국내우선권";
        break;
      case 4:
        str = "CA";
        break;
      case 5:
        str = "DA";
        break;
      case 6:
        str = "CIP";
        break;
      case 7:
        str = "재출원";
        break;
    }
    return str;
  },

  convertDesignStateToText(state) {
    let str = "";
    switch (state) {
      case 0:
        str = "디자인 창작물 접수";
        break;
      case 1:
        str = "초안 작성 요청";
        break;
      case 2:
        str = "초안 검토 대기";
        break;
      case 3:
        str = "초안 수정본 전달";
        break;
      case 4:
        str = "초안 최종본 검토 대기";
        break;
      case 5:
        str = "출원 지시";
        break;
      case 6:
        str = "출원 완료";
        break;
      case 7:
        str = "심사 청구 요청 상태";
        break;
      case 8:
        str = "등록 결정 상태 (NOA)";
        break;
      case 9:
        str = "등록 완료";
        break;
      case 10:
        str = "심사 청구 거절 이유 (OA)";
        break;
      case 11:
        str = "oa 대응안 검토 대기";
        break;
      case 12:
        str = "oa 대응안 수정본 업로드";
        break;
      case 13:
        str = "oa 대응한 최종본 접수";
        break;
      case 14:
        str = "oa 초안 작성 지시";
        break;
      case 15:
        str = "oa 초안 접수";
        break;
      case 16:
        str = "oa 초안 수정본 전달";
        break;
      case 17:
        str = "oa 초안 최종본 접수";
        break;
      case 18:
        str = "oa 제출 지시";
        break;
      case 19:
        str = "번역문 초안 작성 지시";
        break;
      case 20:
        str = "번역문 초안 검토 대기";
        break;
      case 21:
        str = "번역문 초안 수정본 전달";
        break;
      case 22:
        str = "번역문 최종본 검토 대기";
        break;
      case 99:
        str = "종료";
        break;
    }
    return str;
  },

  convertTerminationToText(state) {
    let str = "";
    switch (state) {
      case 0:
        str = "무효";
        break;
      case 1:
        str = "취하";
        break;
      case 2:
        str = "포기";
        break;
      case 3:
        str = "거절";
        break;
      case 4:
        str = "소멸";
        break;
      case 5:
        str = "기타";
        break;
      case 6:
        str = "양도";
        break;
    }
    return str;
  },

  convertStateToText(state) {
    let str = "";
    switch (state) {
      case 0:
        str = "발명 신고서 접수";
        break;
      case 1:
        str = "선행기술 조사 신청 상태";
        break;
      case 2:
        str = "선행기술 조사 완료";
        break;
      case 3:
        str = "초안 작성 요청";
        break;
      case 4:
        str = "초안 검토 대기";
        break;
      case 5:
        str = "초안 수정본 전달";
        break;
      case 6:
        str = "초안 최종본 검토 대기";
        break;
      case 7:
        str = "출원 지시";
        break;
      case 8:
        str = "출원 완료";
        break;
      case 9:
        str = "심사중";
        break;
      case 10:
        str = "등록 결정 상태 (NOA)";
        break;
      case 11:
        str = "분할 출원 상태";
        break;
      case 12:
        str = "등록 완료";
        break;
      case 13:
        str = "심사 청구 거절 이유(OA)";
        break;
      case 14:
        str = "oa 대응안 검토 대기";
        break;
      case 15:
        str = "oa 대응안 수정본 업로드";
        break;
      case 16:
        str = "oa 대응한 최종본 접수";
        break;
      case 17:
        str = "oa 초안 작성 지시";
        break;
      case 18:
        str = "oa 초안 접수";
        break;
      case 19:
        str = "oa 초안 수정본 전달";
        break;
      case 20:
        str = "oa 초안 최종본 접수";
        break;
      case 21:
        str = "oa 제출 지시";
        break;
      case 22:
        str = "번역문 초안 작성 지시";
        break;
      case 23:
        str = "번역문 초안 검토 대기";
        break;
      case 24:
        str = "번역문 초안 수정본 전달";
        break;
      case 25:
        str = "번역문 최종본 검토 대기";
        break;
      case 26:
        str = "우선심사청구 요청";
        break;
      case 27:
        str = "가출원";
        break;
      // case 28:
      //   str = "양도";
      //   break;
      case 99:
        str = "종료";
        break;
    }
    return str;
  },

  convertInventionStateToStr(state) {
    return convertInventionStateLabel(state);
  },
  // rank
  // 기업
  // 0 : 경영진
  // 1 : 관리자
  // 2 : 발명자
  // 9 : 슈퍼 계정
  // 특허사무소
  // 10 : 대표
  // 11 : 관리자
  // 12 : 담당자
  // 19 : 슈퍼 계정
  // 투자자
  // 29 : 투자자
  checkAuth(type, auth) {
    switch (type) {
      case "모두":
        return true;
      case "특허회사":
        return auth < 10;
      case "경영진":
        return auth == 0;
      case "특허회사_관리자":
        return auth == 0 || auth == 1 || auth == 9;
      case "특허회사_발명자만":
        return auth == 2;
      case "대리인":
        return 20 > auth && auth >= 10;
      case "대리인_관리자":
        return auth == 10 || auth == 11 || auth == 19;
      case "대리인_담당자":
        return auth == 10 || auth == 11 || auth == 12;
      case "대리인_담당자만":
        return auth == 12;
      case "투자자":
        return auth == 29;
      case "슈퍼계정":
        return auth == 9 || auth == 19;
    }
  },

  convertAccountType(type) {
    switch (Number(type)) {
      case companyType.comapny:
        return "법인기업 · 대학 · 연구소";
        break;
      case companyType.agent:
        return "특허사무소";
      case companyType.invester:
        return "투자자";
      case companyType.person:
        return "개인";
    }
  },

  download(url, payload, type, setIsLoading, setDownloadComplete) {
    const path = String(url || "").replace(/^\/+/, "");
    let req = new XMLHttpRequest();
    req.open("POST", config.url + `/api/v1/${path}`, true);
    req.setRequestHeader("X-token", window.$Global.getToken());
    applyWorkingCompanyXhrHeaders(req, path);
    if (type === 1) {
      req.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
    } else {
      req.setRequestHeader("Content-Type", "text/json;charset=utf8");
    }
    req.responseType = "blob";

    req.onload = function () {
      if (this.status === 200) {
        if (payload && payload.excel === 1) {
          alert("다운로드 완료");
        }
        let blob = this.response;
        let filename = "";
        let disposition = req.getResponseHeader("Content-Disposition");

        if (disposition && disposition.indexOf("attachment") !== -1) {
          // filename*=UTF-8''... 우선 (한글 파일명)
          const starMatch = /filename\*\s*=\s*UTF-8''([^;\n]+)/i.exec(
            disposition
          );
          if (starMatch && starMatch[1]) {
            filename = starMatch[1].trim().replace(/['"]/g, "");
          } else {
            const filenameRegex = /filename\s*=\s*((['"]).*?\2|[^;\n]*)/i;
            const matches = filenameRegex.exec(disposition);
            if (matches != null && matches[1])
              filename = matches[1].replace(/['"]/g, "");
          }
        }

        if (typeof window.navigator.msSaveBlob !== "undefined") {
          // IE workaround for "HTML7007: One or more blob URLs were revoked by closing the blob for which they were created. These URLs will no longer resolve as the data backing the URL has been freed."
          window.navigator.msSaveBlob(blob, filename);
        } else {
          let URL = window.URL || window.webkitURL;
          let downloadUrl = URL.createObjectURL(blob);

          if (filename) {
            let a = document.createElement("a");
            if (typeof a.download === "undefined") {
              window.location.href = downloadUrl;
            } else {
              a.href = downloadUrl;
              // a.target = "_blank";
              try {
                a.download = decodeURIComponent(filename);
              } catch (e) {
                a.download = filename;
              }
              document.body.appendChild(a);
              a.click();
            }
          } else {
            // Content-Disposition 못 읽어도 저장 시도
            let a = document.createElement("a");
            a.href = downloadUrl;
            a.download = "download";
            document.body.appendChild(a);
            a.click();
          }

          setTimeout(function () {
            URL.revokeObjectURL(downloadUrl);
          }, 1000); // cleanup
        }
      } else {
        let blob = this.response,
          fr = new FileReader();

        fr.onload = function () {
          try {
            alert(JSON.parse(this.result).message);
          } catch (e) {
            alert("파일 다운로드에 실패했습니다.");
          }
        };

        fr.readAsText(blob);
      }
      // setIsLoading과 setDownloadComplete가 존재할 때만 호출
      if (setIsLoading) setIsLoading(false);
      if (setDownloadComplete) setDownloadComplete(false);
    };

    req.onerror = function () {
      alert("파일 다운로드 요청에 실패했습니다. API 주소/서버 상태를 확인해주세요.");
      if (setIsLoading) setIsLoading(false);
      if (setDownloadComplete) setDownloadComplete(false);
    };

    if (payload !== undefined) {
      let queryStr = "";
      for (const [key, value] of Object.entries(payload)) {
        queryStr += key + "=" + value + "&";
      }
      req.send(queryStr.slice(0, -1));
    } else {
      req.send(JSON.stringify(payload));
    }
  },

  async downloadViaFetch(url, payload, type) {
    const path = String(url || "").replace(/^\/+/, "");
    const apiUrl = `${config.url}/api/v1/${path}`;
    const token = window.$Global.getToken();

    let headers = new Headers({
      "X-token": token,
      "Content-Type":
        type === 1 ? "application/x-www-form-urlencoded" : "application/json",
    });

    let body;
    if (payload) {
      body =
        type === 1
          ? new URLSearchParams(payload).toString()
          : JSON.stringify(payload);
    }

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: headers,
        body: body,
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(JSON.parse(errorText).message);
      }

      const blob = await response.blob();
      const disposition = response.headers.get("Content-Disposition");
      let filename = "download";

      if (disposition && disposition.indexOf("attachment") !== -1) {
        const starMatch = /filename\*\s*=\s*UTF-8''([^;\n]+)/i.exec(
          disposition
        );
        if (starMatch && starMatch[1]) {
          filename = starMatch[1].trim().replace(/['"]/g, "");
        } else {
          const filenameRegex = /filename\s*=\s*((['"]).*?\2|[^;\n]*)/i;
          const matches = filenameRegex.exec(disposition);
          if (matches != null && matches[1]) {
            filename = matches[1].replace(/['"]/g, "");
          }
        }
      }

      if (window.navigator.msSaveBlob) {
        // IE workaround
        window.navigator.msSaveBlob(blob, filename);
      } else {
        const objectUrl = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.style.display = "none";
        a.href = objectUrl;
        try {
          a.download = decodeURIComponent(filename);
        } catch (e) {
          a.download = filename;
        }
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(objectUrl);
      }
    } catch (error) {
      console.error("Download failed:", error);
      alert(error.message || "파일 다운로드에 실패했습니다.");
    }
  },

  extractTextFromHTML(html) {
    // Create a temporary element to parse the HTML
    const temp = document.createElement("div");
    temp.innerHTML = html;

    // Function to recursively extract text from nodes
    function extractTextFromNode(node) {
      let text = "";

      if (node.nodeType === Node.TEXT_NODE) {
        // If it's a text node, just return its content
        return node.textContent;
      } else if (node.nodeType === Node.ELEMENT_NODE) {
        // If it's an element node, handle special cases and recurse
        const tagName = node.tagName.toLowerCase();

        // Add newlines for block-level elements
        if (
          [
            "div",
            "p",
            "br",
            "h1",
            "h2",
            "h3",
            "h4",
            "h5",
            "h6",
            "ul",
            "ol",
            "li",
          ].includes(tagName)
        ) {
          text += "\n";
        }

        // Recurse through child nodes
        for (let child of node.childNodes) {
          text += extractTextFromNode(child);
        }

        // Add another newline after certain block elements
        if (
          ["p", "h1", "h2", "h3", "h4", "h5", "h6", "ul", "ol"].includes(
            tagName
          )
        ) {
          text += "\n";
        }
      }

      return text;
    }

    // Extract text from the temporary element
    let extractedText = extractTextFromNode(temp);

    // Clean up extra whitespace
    extractedText = extractedText.replace(/\n{3,}/g, "\n\n").trim();

    return extractedText;
  },

  download_regist(url, payload, type) {
    let req = new XMLHttpRequest();
    req.open("POST", "https://www.ipnow.co.kr" + `/api/v1/${url}`, true);
    req.setRequestHeader(
      "X-token",
      "bfac6afde610fd90fa306c69a87fc1f8:f03392bad3950169e1ad3037a91b3b0186cf4241c1a9a09054afccbcbe4707ab14f9a81a4f41ad5a5c9569edd971d7ec9e7c7c7b7f29282893bb793853209e515dfbea8ba3c9ad5bc72ddf2b26648a798b8de3fbac99d7a507e09130b9dcc34633d87d1c6f4ce706bb11a8720e2803611d160c27f2456d5e682941d14c6d1c1d493abf32470decea1692f26430db3f043a23093137eee700f5149abfc5f580681fc2396d5462a2e1e17e5727e3bc3f6c584d153ff261e79dc3dec8ad39c5eea8ea4ff1c0d1f9d468ef154cb45c4cac771a9faa44d0745463c613a1c486a99793c74e674d01efd1b21d040ed8ccd13abee119ea95fb60a323aff839f0c35e0b5e7874115e958de3276b979b90c12ff30e4827a5b6149978c9bf54ca6fe25da03c"
    );
    if (type === 1) {
      req.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
    } else {
      req.setRequestHeader("Content-Type", "text/json;charset=utf8");
    }
    req.responseType = "blob";

    req.onload = function () {
      if (this.status === 200) {
        let blob = this.response;
        let filename = "";
        let disposition = req.getResponseHeader("Content-Disposition");

        if (disposition && disposition.indexOf("attachment") !== -1) {
          let filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
          let matches = filenameRegex.exec(disposition);
          if (matches != null && matches[1])
            filename = matches[1].replace(/['"]/g, "");
        }

        if (typeof window.navigator.msSaveBlob !== "undefined") {
          // IE workaround for "HTML7007: One or more blob URLs were revoked by closing the blob for which they were created. These URLs will no longer resolve as the data backing the URL has been freed."
          window.navigator.msSaveBlob(blob, filename);
        } else {
          let URL = window.URL || window.webkitURL;
          let downloadUrl = URL.createObjectURL(blob);

          if (filename) {
            let a = document.createElement("a");
            if (typeof a.download === "undefined") {
              window.location.href = downloadUrl;
            } else {
              a.href = downloadUrl;
              // a.target = "_blank";
              a.download = decodeURIComponent(filename);
              document.body.appendChild(a);
              a.click();
            }
          } else {
            window.location.href = downloadUrl;
          }

          setTimeout(function () {
            URL.revokeObjectURL(downloadUrl);
          }, 100); // cleanup
        }
      } else {
        let blob = this.response,
          fr = new FileReader();

        fr.onload = function () {
          alert(JSON.parse(this.result).message);
        };

        fr.readAsText(blob);
      }
    };

    if (payload !== undefined) {
      let queryStr = "";
      for (const [key, value] of Object.entries(payload)) {
        queryStr += key + "=" + value + "&";
      }
      req.send(queryStr.slice(0, -1));
    } else {
      req.send(JSON.stringify(payload));
    }
  },

  download_get(url, payload, type, setIsLoading, setDownloadComplete) {
    let req = new XMLHttpRequest();
    let queryStr = Object.entries(payload.params)
      .map(
        ([key, value]) =>
          `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
      )
      .join("&");
    req.open("GET", config.url + `/api/v1/${url}?${queryStr}`, true);
    req.setRequestHeader("X-token", window.$Global.getToken());
    applyWorkingCompanyXhrHeaders(req, url);
    if (type === 1) {
      req.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
    } else {
      req.setRequestHeader("Content-Type", "text/json;charset=utf8");
    }
    req.responseType = "blob";

    req.onload = function () {
      if (this.status === 200) {
        let blob = this.response;
        let filename = "";
        let disposition = req.getResponseHeader("Content-Disposition");

        if (disposition && disposition.indexOf("attachment") !== -1) {
          // filename*=UTF-8''... 우선 (한글 파일명) — download() 와 동일
          // 구 regex(filename[^;=]*=)는 filename* 의 "UTF-8''" 가 파일명에 남음
          const starMatch = /filename\*\s*=\s*UTF-8''([^;\n]+)/i.exec(
            disposition
          );
          if (starMatch && starMatch[1]) {
            filename = starMatch[1].trim().replace(/['"]/g, "");
          } else {
            const filenameRegex = /filename\s*=\s*((['"]).*?\2|[^;\n]*)/i;
            const matches = filenameRegex.exec(disposition);
            if (matches != null && matches[1])
              filename = matches[1].replace(/['"]/g, "");
          }
        }

        let decodedFilename = filename;
        if (filename) {
          try {
            decodedFilename = decodeURIComponent(filename);
          } catch (e) {
            decodedFilename = filename;
          }
        }

        if (typeof window.navigator.msSaveBlob !== "undefined") {
          // IE workaround for "HTML7007: One or more blob URLs were revoked by closing the blob for which they were created. These URLs will no longer resolve as the data backing the URL has been freed."
          window.navigator.msSaveBlob(blob, decodedFilename);
        } else {
          let URL = window.URL || window.webkitURL;
          let downloadUrl = URL.createObjectURL(blob);

          if (decodedFilename) {
            let a = document.createElement("a");
            if (typeof a.download === "undefined") {
              window.location.href = downloadUrl;
            } else {
              a.href = downloadUrl;
              a.download = decodedFilename;
              document.body.appendChild(a);
              a.click();
            }
          } else {
            window.location.href = downloadUrl;
          }

          setTimeout(function () {
            URL.revokeObjectURL(downloadUrl);
          }, 100); // cleanup
        }
      } else {
        let blob = this.response,
          fr = new FileReader();

        fr.onload = function () {
          alert(JSON.parse(this.result).message);
        };

        fr.readAsText(blob);
      }
      // setIsLoading과 setDownloadComplete가 존재할 때만 호출
      if (setIsLoading) setIsLoading(false);
      if (setDownloadComplete) setDownloadComplete(false);
    };

    if (payload !== undefined) {
      let queryStr = "";
      for (const [key, value] of Object.entries(payload)) {
        queryStr += key + "=" + value + "&";
      }
      req.send(queryStr.slice(0, -1));
    } else {
      req.send(JSON.stringify(payload));
    }
  },

  newDownload(url, payload) {
    let req = new XMLHttpRequest();
    req.open("POST", config.url + `/api/v1/${url}`, true);
    req.setRequestHeader("X-token", window.$Global.getToken());
    applyWorkingCompanyXhrHeaders(req, url);
    req.setRequestHeader("Content-Type", "application/json;charset=utf8");
    req.responseType = "blob";

    req.onload = function () {
      if (this.status === 200) {
        let blob = this.response;
        let filename = "";
        let disposition = req.getResponseHeader("Content-Disposition");

        if (disposition && disposition.indexOf("attachment") !== -1) {
          let filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
          let matches = filenameRegex.exec(disposition);
          if (matches != null && matches[1])
            filename = matches[1].replace(/['"]/g, "");
        }

        if (typeof window.navigator.msSaveBlob !== "undefined") {
          // IE workaround for "HTML7007: One or more blob URLs were revoked by closing the blob for which they were created. These URLs will no longer resolve as the data backing the URL has been freed."
          window.navigator.msSaveBlob(blob, filename);
        } else {
          let URL = window.URL || window.webkitURL;
          let downloadUrl = URL.createObjectURL(blob);

          if (filename) {
            let a = document.createElement("a");
            if (typeof a.download === "undefined") {
              window.location.href = downloadUrl;
            } else {
              a.href = downloadUrl;
              a.download = decodeURIComponent(filename);
              document.body.appendChild(a);
              a.click();
            }
          } else {
            window.location.href = downloadUrl;
          }

          setTimeout(function () {
            URL.revokeObjectURL(downloadUrl);
          }, 100); // cleanup
        }
      } else {
        let blob = this.response,
          fr = new FileReader();

        fr.onload = function () {
          alert(JSON.parse(this.result).message);
        };

        fr.readAsText(blob);
      }
    };

    req.send(JSON.stringify(payload));
  },
  async fileDownloadSync(url, payload) {
    const conf = {
      method: "POST",
      url: config.url + `/api/v1/${url}`,
      headers: {
        ContentType: "application/json",
        "x-token": sessionStorage.getItem("token"),
      },
      responseType: "blob",
      data: payload,
    };

    let response;
    try {
      response = await axios(conf);
    } catch (e) {
      const status = e.response.status;
      if (status === 400) {
        alert("올바르지 않은 파라미터 업로드");
      } else if (status === 700) {
        alert("특허 조회에 실패했습니다.");
      }
      return;
    }
    const name = decodeURI(
      response.headers["content-disposition"]
        .split("filename=")[1]
        .replace(/"/g, "")
    );
    const uri = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = uri;
    link.setAttribute("download", name);
    link.style.cssText = "display:none";
    document.body.appendChild(link);
    link.click();
    link.remove();
  },

  dataDownload(res) {
    let req = res.headers;
    let blob = res.data;
    let filename = "";

    let disposition = req["content-disposition"];
    if (disposition && disposition.indexOf("attachment") !== -1) {
      let filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
      let matches = filenameRegex.exec(disposition);
      if (matches != null && matches[1])
        filename = matches[1].replace(/['"]/g, "");
    }

    if (typeof window.navigator.msSaveBlob !== "undefined") {
      window.navigator.msSaveBlob(blob, filename);
    } else {
      let URL = window.URL || window.webkitURL;
      let downloadUrl = URL.createObjectURL(new Blob([blob]));

      if (filename) {
        let a = document.createElement("a");
        if (typeof a.download === "undefined") {
          window.location.href = downloadUrl;
        } else {
          a.href = downloadUrl;
          a.download = decodeURIComponent(filename);
          document.body.appendChild(a);
          a.click();
        }
      } else {
        window.location.href = downloadUrl;
      }

      setTimeout(function () {
        URL.revokeObjectURL(downloadUrl);
      }, 100); // cleanup
    }
  },

  convertNationCodeToStr(no) {
    return nationType.find((item, idx) => {
      let result = "";
      if (no === idx) {
        result = item;
      }
      return result;
    });
  },

  convertTradeMarkNationCodeToStr(no) {
    if (no == null || no === "") return "";
    const code = Number(no);
    if (!Number.isFinite(code)) return "";
    const found = Object.entries(tradeMarkNationType).find(
      ([, value]) => value === code
    );
    return found ? found[0] : "";
  },

  convertChildNationCodeToStr(no) {
    switch (no) {
      case 0:
        return "AL"; // 알바니아 (Albania)
      case 1:
        return "AT"; // 오스트리아 (Austria)
      case 2:
        return "BE"; // 벨기에 (Belgium)
      case 3:
        return "BG"; // 불가리아 (Bulgaria)
      case 4:
        return "CH"; // 스위스 (Switzerland)
      case 5:
        return "CY"; // 키프로스 (Cyprus)
      case 6:
        return "CZ"; // 체코 (Czech Republic)
      case 7:
        return "DE"; // 독일 (Germany)
      case 8:
        return "DK"; // 덴마크 (Denmark)
      case 9:
        return "EE"; // 에스토니아 (Estonia)
      case 10:
        return "ES"; // 스페인 (Spain)
      case 11:
        return "FI"; // 핀란드 (Finland)
      case 12:
        return "FR"; // 프랑스 (France)
      case 13:
        return "GB"; // 영국 (United Kingdom)
      case 14:
        return "GR"; // 그리스 (Greece)
      case 15:
        return "HR"; // 크로아티아 (Croatia)
      case 16:
        return "HU"; // 헝가리 (Hungary)
      case 17:
        return "IE"; // 아일랜드 (Ireland)
      case 18:
        return "IS"; // 아이슬란드 (Iceland)
      case 19:
        return "IT"; // 이탈리아 (Italy)
      case 20:
        return "LI"; // 리히텐슈타인 (Liechtenstein)
      case 21:
        return "LT"; // 리투아니아 (Lithuania)
      case 22:
        return "LU"; // 룩셈부르크 (Luxembourg)
      case 23:
        return "LV"; // 라트비아 (Latvia)
      case 24:
        return "MC"; // 모나코 (Monaco)
      case 25:
        return "MK"; // 북마케도니아 (North Macedonia)
      case 26:
        return "MT"; // 몰타 (Malta)
      case 27:
        return "NL"; // 네덜란드 (Netherlands)
      case 28:
        return "NO"; // 노르웨이 (Norway)
      case 29:
        return "PL"; // 폴란드 (Poland)
      case 30:
        return "PT"; // 포르투갈 (Portugal)
      case 31:
        return "RO"; // 루마니아 (Romania)
      case 32:
        return "RS"; // 세르비아 (Serbia)
      case 33:
        return "SE"; // 스웨덴 (Sweden)
      case 34:
        return "SI"; // 슬로베니아 (Slovenia)
      case 35:
        return "SK"; // 슬로바키아 (Slovakia)
      case 36:
        return "SM"; // 산마리노 (San Marino)
      case 37:
        return "TR"; // 터키 (Turkey)
      case 38:
        return "SG"; // 싱가포르 (Singapore)
      case 39:
        return "UP"; // 유럽연합 단일특허 (Unitary Patent)
      case 40:
        return "BA"; // 보스니아 헤르체고비나 (Bosnia and Herzegovina)
      case 41:
        return "MD"; // 몰도바 (Moldova)
      case 42:
        return "ME"; // 몬테네그로 (Montenegro)
    }
  },

  convertNationCodeToKoreanStr(no) {
    return nationStrType.find((item, idx) => {
      let result = "";
      if (no === idx) result = item;
      return result;
    });
  },

  convertEPNationCodeToKoreanStr(no) {
    switch (no) {
      case 0:
        return { name: "알바니아", flag: "🇦🇱" };
      case 1:
        return { name: "오스트리아", flag: "🇦🇹" };
      case 2:
        return { name: "벨기에", flag: "🇧🇪" };
      case 3:
        return { name: "불가리아", flag: "🇧🇬" };
      case 4:
        return { name: "스위스", flag: "🇨🇭" };
      case 5:
        return { name: "키프로스", flag: "🇨🇾" };
      case 6:
        return { name: "체코", flag: "🇨🇿" };
      case 7:
        return { name: "독일", flag: "🇩🇪" };
      case 8:
        return { name: "덴마크", flag: "🇩🇰" };
      case 9:
        return { name: "에스토니아", flag: "🇪🇪" };
      case 10:
        return { name: "스페인", flag: "🇪🇸" };
      case 11:
        return { name: "핀란드", flag: "🇫🇮" };
      case 12:
        return { name: "프랑스", flag: "🇫🇷" };
      case 13:
        return { name: "영국", flag: "🇬🇧" };
      case 14:
        return { name: "그리스", flag: "🇬🇷" };
      case 15:
        return { name: "크로아티아", flag: "🇭🇷" };
      case 16:
        return { name: "헝가리", flag: "🇭🇺" };
      case 17:
        return { name: "아일랜드", flag: "🇮🇪" };
      case 18:
        return { name: "아이슬란드", flag: "🇮🇸" };
      case 19:
        return { name: "이탈리아", flag: "🇮🇹" };
      case 20:
        return { name: "리히텐슈타인", flag: "🇱🇮" };
      case 21:
        return { name: "리투아니아", flag: "🇱🇹" };
      case 22:
        return { name: "룩셈부르크", flag: "🇱🇺" };
      case 23:
        return { name: "라트비아", flag: "🇱🇻" };
      case 24:
        return { name: "모나코", flag: "🇲🇨" };
      case 25:
        return { name: "북마케도니아", flag: "🇲🇰" };
      case 26:
        return { name: "몰타", flag: "🇲🇹" };
      case 27:
        return { name: "네덜란드", flag: "🇳🇱" };
      case 28:
        return { name: "노르웨이", flag: "🇳🇴" };
      case 29:
        return { name: "폴란드", flag: "🇵🇱" };
      case 30:
        return { name: "포르투갈", flag: "🇵🇹" };
      case 31:
        return { name: "루마니아", flag: "🇷🇴" };
      case 32:
        return { name: "세르비아", flag: "🇷🇸" };
      case 33:
        return { name: "스웨덴", flag: "🇸🇪" };
      case 34:
        return { name: "슬로베니아", flag: "🇸🇮" };
      case 35:
        return { name: "슬로바키아", flag: "🇸🇰" };
      case 36:
        return { name: "산마리노", flag: "🇸🇲" };
      case 37:
        return { name: "튀르키예", flag: "🇹🇷" };
      case 38:
        return { name: "싱가포르", flag: "🇸🇬" };
      case 39:
        return { name: "UP(단일특허)", flag: "🇪🇺" }; // 단일특허라서 EU 깃발로 표시
      case 40:
        return { name: "보스니아 헤르체고비나", flag: "🇧🇦" };
      case 41:
        return { name: "몰도바", flag: "🇲🇩" };
      case 42:
        return { name: "몬테네그로", flag: "🇲🇪" };
      default:
        return { name: "알 수 없음", flag: "🌐" };
    }
  },

  convertTradeMarkStateCodeToStr(no) {
    switch (no) {
      case 0:
        return "준비중";
      case 1:
        return "선행상표조사";
      case 2:
        return "선행상표조사 완료";
      case 3:
        return "출원신청";
      case 4:
        return "출원완료";
      case 5:
        return "등록신청";
      case 6:
        return "등록결정";
      case 7:
        return "등록완료";
      case 8:
        return "oa";
      case 9:
        return "oa의견 전달 받은 상태";
      case 10:
        return "oa제출 요청상태";
      case 11:
        return "이의신청 상태";
      case 12:
        return "이의신청 의견서 접수 상태";
      case 13:
        return "갱신 신청 상태";
      case 14:
        return "갱신 요청 상태";
      case 80:
        return "공고";
      case 98:
        return "거절(미확정)";
      case 99:
        return "종료";
    }
  },

  parseJsonArray(arr) {
    if (!arr) return;
    return arr.filter((item) => {
      item.type = "account";
      item.password = "****";
      delete item.company_idx;
      delete item.company_name;
      delete item.created_at;
      delete item.rank;
      return item;
    });
  },

  setWeekendColor(date) {
    return date.getDay() === 0 || date.getDay() === 6 ? "color_red" : "";
  },

  cloneObject(obj) {
    let clone = {};
    for (var key in obj) {
      if (typeof obj[key] == "object" && obj[key] != null) {
        clone[key] = this.cloneObject(obj[key]);
      } else {
        clone[key] = obj[key];
      }
    }

    return clone;
  },

  getInfoMessage(text) {
    if (text == null || text === "") return "";
    let str = String(text).replace(/ /g, "").replace(/\n/g, "");
    // 우선권 1, 우선권 2 에 대한 예외 처리 코드 추가
    if (str.substr(0, 3) == "우선권") {
      str = str.substr(0, 3);
    }
    let data = {
      관리번호:
        "내부에서 특허를 식별하고 관리하기 위한 번호입니다. 기본적으로 특허별 관리번호가 자동 생성되며, 필요에 따라 수정할 수 있습니다. 예: P-2020-0001-KR(P: 특허, 2020: 출원 연도, 0001: 해당 연도의 일련번호, KR: 국가 코드). 별도의 내부 관리번호를 사용하는 경우 직접 입력하세요.",

      유형: "출원 유형을 선택합니다. 신규출원(원출원), 분할출원, 변경출원, 국내우선권출원 중 해당하는 유형을 선택하세요.",

      담당자:
        "기업 내 담당자를 설정합니다. 담당자로 지정할 사용자는 먼저 사용자 관리 페이지에서 관리자로 등록되어 있어야 합니다.",

      관리담당자:
          "기업 내 담당자를 설정합니다. 담당자로 지정할 사용자는 먼저 사용자 관리 페이지에서 관리자로 등록되어 있어야 합니다.",

      대리인담당자:
        "기업 내 담당자를 설정합니다. 담당자로 지정할 사용자는 먼저 사용자 관리 페이지에서 관리자로 등록되어 있어야 합니다.",

      발명자1: "발명신고서에 입력된 발명자 정보가 표시됩니다.",

      대리인:
        "대리인을 설정합니다. 먼저 사용자 관리 페이지에서 대리인을 등록해야 합니다. 대리인을 지정하면 해당 사건의 정보가 대리인과 공유되며, 대리인에게는 비밀유지의무가 적용됩니다.",

      현지대리인:
        "국제특허 사건에 현지대리인이 있는 경우 해당 대리인을 설정합니다.",

      발명신고서:
        "발명자가 사용자 계정으로 로그인한 후 직무발명신고서 상세 페이지에서 신고서를 업로드하면 해당 날짜가 접수일로 기록됩니다. 관리자가 직무발명신고서 접수 현황에서 출원 여부를 결정하면 접수일과 신고서가 이 페이지에 표시됩니다. 이 페이지에서 신고서를 업로드하거나 다운로드할 수 있으며, 해당 내용은 특허사무소용 페이지에도 공유됩니다.",

      발명신고서접수:
        "발명자가 사용자 계정으로 로그인한 후 직무발명신고서 상세 페이지에서 신고서를 업로드하면 해당 날짜가 접수일로 기록됩니다. 관리자가 직무발명신고서 접수 현황에서 출원 여부를 결정하면 접수일과 신고서가 이 페이지에 표시됩니다. 이 페이지에서 신고서를 업로드하거나 다운로드할 수 있으며, 해당 내용은 특허사무소용 페이지에도 공유됩니다.",

      선행기술조사:
        "선행기술조사 여부를 표시하며, 관련 파일을 업로드하거나 다운로드할 수 있습니다.",

      프로젝트명: "출원과 관련된 프로젝트 정보를 입력합니다.",

      초안작성지시:
        "대리인에게 명세서 초안 작성을 지시합니다. 버튼을 누르면 지시가 전달되고 지시일이 표시됩니다. 지시일은 직접 변경할 수 없습니다.",

      초안작성지시일:
        "대리인에게 명세서 초안 작성을 지시합니다. 버튼을 누르면 지시가 전달되고 지시일이 표시됩니다. 지시일은 직접 변경할 수 없습니다.",

      초안작성지시접수일:
        "대리인에게 명세서 초안 작성을 지시합니다. 버튼을 누르면 지시가 전달되고 지시일이 표시됩니다. 지시일은 직접 변경할 수 없습니다.",

      초안접수:

        "명세서 초안의 접수일을 표시하며, 초안 파일을 업로드하거나 다운로드할 수 있습니다. 대리인이 파일을 업로드한 날짜가 접수일로 기록됩니다. 내부 기한이 설정된 경우에는 접수 전까지 해당 기한이 표시되며, 초안이 접수되면 실제 접수일로 변경됩니다.",

      초안전달:
        "명세서 초안의 접수일을 표시하며, 초안 파일을 업로드하거나 다운로드할 수 있습니다. 대리인이 파일을 업로드한 날짜가 접수일로 기록됩니다. 내부 기한이 설정된 경우에는 접수 전까지 해당 기한이 표시되며, 초안이 접수되면 실제 접수일로 변경됩니다.",

      초안발명자검토:
        "명세서 초안에 대한 발명자의 검토 기한을 표시합니다. 이는 법적 기한이 아닌 회사 내부 업무 처리 기한입니다. 발명자 검토 파일을 업로드하거나 다운로드할 수 있습니다.",

      초안발명자검토일:
        "명세서 초안에 대한 발명자의 검토 기한을 표시합니다. 이는 법적 기한이 아닌 회사 내부 업무 처리 기한입니다. 발명자 검토 파일을 업로드하거나 다운로드할 수 있습니다.",

      초안담당자검토:
        "명세서 초안에 대한 담당자의 검토 기한을 표시합니다. 이는 법적 기한이 아닌 회사 내부 업무 처리 기한입니다. 담당자 검토 파일을 업로드하거나 다운로드할 수 있습니다.",

      초안담당자검토일:
        "명세서 초안에 대한 담당자의 검토 기한을 표시합니다. 이는 법적 기한이 아닌 회사 내부 업무 처리 기한입니다. 담당자 검토 파일을 업로드하거나 다운로드할 수 있습니다.",

      초안수정본전달:
        "대리인에게 전달할 명세서 초안 검토 의견을 업로드합니다. 대리인은 의견을 확인해 초안을 수정한 후 수정본을 업로드합니다. 수정본 파일을 업로드하거나 다운로드할 수 있으며, 대리인이 수정본을 업로드한 날짜가 접수일로 기록됩니다. 내부 기한이 설정된 경우에는 접수 전까지 해당 기한이 표시되고, 수정본이 접수되면 실제 접수일로 변경됩니다.",

      초안수정본접수:
        "대리인에게 전달할 명세서 초안 검토 의견을 업로드합니다. 대리인은 의견을 확인해 초안을 수정한 후 수정본을 업로드합니다. 수정본 파일을 업로드하거나 다운로드할 수 있으며, 대리인이 수정본을 업로드한 날짜가 접수일로 기록됩니다. 내부 기한이 설정된 경우에는 접수 전까지 해당 기한이 표시되고, 수정본이 접수되면 실제 접수일로 변경됩니다.",

      초안최종본접수:
        "명세서 초안 최종본의 접수일을 표시하며, 최종본 파일을 업로드하거나 다운로드할 수 있습니다. 대리인이 최종본을 업로드한 날짜가 접수일로 기록됩니다. 내부 기한이 설정된 경우에는 최종본 접수 전까지 해당 기한이 표시되고, 접수 후에는 실제 접수일로 변경됩니다.",

      출원지시:
        "대리인에게 출원을 지시합니다. 버튼을 누르면 지시가 전달되고 지시일이 표시됩니다.",

      출원지시일:
        "대리인에게 출원을 지시합니다. 버튼을 누르면 지시가 전달되고 지시일이 표시됩니다.",

      출원지시접수:
        "대리인에게 출원을 지시합니다. 버튼을 누르면 지시가 전달되고 지시일이 표시됩니다.",

      심사청구:
        "대리인에게 심사청구를 지시합니다. 버튼을 누르면 지시가 전달되고 지시일이 표시되며, 지시일은 직접 변경할 수 없습니다. 국내 특허출원은 심사청구를 해야 심사가 진행되며, 심사를 통과해야 특허권을 등록할 수 있습니다. 심사청구 기간은 출원일부터 3년입니다.",

      우선심사청구:
        "대리인에게 우선심사청구를 지시합니다. 우선심사를 신청하면 일반적인 심사보다 빠르게 등록 여부를 심사받을 수 있습니다. 버튼을 누르면 지시가 전달되고 지시일이 표시되며, 지시일은 직접 변경할 수 없습니다.",

      심사청구일: "심사청구일을 표시합니다.",

      심사청구기한:
        "심사청구 기한을 표시합니다. 기한 내에 심사청구를 하지 않으면 출원이 취하된 것으로 간주되어 더 이상 특허를 받을 수 없습니다.",

      출원번호:
        "출원번호를 입력합니다. 입력한 출원번호는 페이지 상단에도 표시됩니다.",

      출원일: "출원 완료 후 실제 출원일이 표시됩니다.",

      국내우선권주장기한:
        "국내우선권을 주장할 수 있는 법정 기한을 표시합니다.",

      우선일:
        "특허 패밀리에서 가장 먼저 출원된 출원의 출원일을 표시합니다. 우선권 판단 시 기준이 되는 날짜입니다.",

      해외우선권주장기한:
        "해외우선권을 주장할 수 있는 법정 기한을 표시합니다.",

      PCT출원기한:
        "PCT 국제출원 기한을 표시합니다. PCT 국제출원을 이용하면 출원할 국가를 결정하는 기한을 실질적으로 약 18개월 연장할 수 있습니다.",

      발명의명칭:
        "특허의 발명 명칭을 입력합니다. 출원 전에는 발명신고서에 기재된 명칭이 표시되며, 출원 완료 후에는 실제 출원된 발명의 명칭이 표시됩니다.",

      영문명칭: "특허 출원 완료 후 영문 발명의 명칭을 입력합니다.",

      OA발행일:
        "OA(Office Action)는 특허 심사 과정에서 발행되는 심사관의 통지입니다. 주요 OA에는 의견제출통지서와 거절결정서 등이 있습니다.",

      OA답변서제출일: "OA 답변서를 제출한 날짜를 표시합니다.",

      대응안발명자검토:
        "대리인이 제안한 OA 대응 방안에 대한 발명자의 검토 내용을 업로드합니다. 사내 특허 담당자의 검토 내용과 별도로 관리할 수 있으며, 이곳에 업로드한 내용은 대리인에게 공개되지 않습니다.",

      대응안담당자검토:
        "대리인이 제안한 OA 대응 방안에 대한 사내 특허 담당자의 검토 내용을 업로드합니다. 발명자 검토 내용과 별도로 관리할 수 있으며, 이곳에 업로드한 내용은 대리인에게 공개되지 않습니다.",

      대응안수정본전달:
        "발명자와 사내 특허 담당자의 검토 의견을 취합해 업로드합니다. 대리인은 전달된 의견을 확인하고 OA 대응 방안을 추가로 검토합니다.",

      대응안최종본접수:
        "대리인이 검토 의견을 반영해 수정한 OA 대응 방안 최종본을 업로드합니다.",

      OA초안작성지시:
        "사내 담당자가 대리인의 OA 대응 방안 최종본을 검토한 후 추가 검토 사항이 없으면, 대리인에게 특허청 제출용 OA 답변서 초안 작성을 지시합니다.",

      OA초안작성지시일:
        "사내 담당자가 대리인의 OA 대응 방안 최종본을 검토한 후 추가 검토 사항이 없으면, 대리인에게 특허청 제출용 OA 답변서 초안 작성을 지시합니다.",

      OA초안접수: "대리인이 작성한 특허청 제출용 OA 답변서 초안입니다.",

      OA수정본전달:
        "OA 답변서 초안에 대한 수정 요청 사항을 대리인에게 전달합니다.",

      OA최종본접수: "수정 요청 사항을 반영한 특허청 제출용 OA 답변서 최종본입니다.",

      OA제출지시:
        "대리인에게 OA 답변서 제출을 지시합니다. 버튼을 누르면 지시가 전달되고 지시일이 표시됩니다.",

      OA제출지시일:
        "대리인에게 OA 답변서 제출을 지시합니다. 버튼을 누르면 지시가 전달되고 지시일이 표시됩니다.",

      OA연장횟수: "OA 답변서 제출 기한을 연장한 횟수를 표시합니다.",

      OA기한:
        "OA 답변서 제출 기한을 표시합니다. 기한 내에 답변서를 제출하지 않으면 출원이 거절될 수 있으므로 반드시 기한을 확인하세요.",

      등록결정일: "특허 등록이 결정된 날짜를 표시합니다.",

      분할출원:
        "분할출원이 진행된 경우 분할출원일과 진행 횟수를 표시합니다.",

      등록일: "특허 등록일을 표시합니다.",

      등록번호: "특허 등록번호를 표시합니다.",

      존속기간만료일:
        "특허권의 존속기간 만료일을 표시합니다. 일반적으로 출원일부터 20년이 되는 날에 만료됩니다. 다만, 만료일 전이라도 연차료를 납부하지 않으면 특허권이 소멸할 수 있습니다.",

      등록기한:
        "특허 등록 기한을 표시합니다. 기한 내에 등록료 납부를 완료해야 합니다.",

      관납료납부기한: "관납료를 납부할 수 있는 기한을 표시합니다.",

      분할출원기한: "분할출원이 가능한 기한을 표시합니다.",

      납부연차:
        "특허 연차료의 납부 연차를 표시합니다. 연차료는 납부 연차에 따라 달라질 수 있습니다.",

      청구항수:
        "등록된 특허의 청구항 수를 표시합니다. 국내 특허는 청구항 수에 따라 연차료가 달라질 수 있습니다.",

      연차료기한:
        "연차료 납부 기한을 표시합니다. 기한 내에 납부하지 않으면 특허권이 소멸할 수 있습니다.",

      연차관리회사: "특허 연차료를 관리하는 회사를 입력합니다.",

      종료일: "특허권 또는 출원 절차의 종료일을 표시합니다.",

      종료사유:
        "특허 또는 출원 절차의 종료 사유를 입력합니다.\n무효: 무효심판으로 특허가 무효가 된 경우\n취하: 등록 전에 출원이 취하된 경우\n포기: 등록 후 특허권을 포기한 경우(예: 등록료 미납)\n거절: 심사 결과 거절이 확정된 경우\n만료: 존속기간 만료로 특허권이 소멸한 경우\n미출원: 발명신고 접수 후 출원하지 않기로 결정한 경우",

      우선권: "우선권 주장의 기초가 되는 원출원 정보를 표시합니다.",

      번역문초안작성지시:
        "대리인에게 번역문 초안 작성을 지시합니다. 버튼을 누르면 지시가 전달되고 지시일이 표시됩니다. 지시일은 직접 변경할 수 없습니다.",

      번역문초안작성지시일:
        "대리인에게 번역문 초안 작성을 지시합니다. 버튼을 누르면 지시가 전달되고 지시일이 표시됩니다. 지시일은 직접 변경할 수 없습니다.",

      번역문초안접수:
        "번역문 초안의 접수일을 표시하며, 초안 파일을 업로드하거나 다운로드할 수 있습니다. 대리인이 번역문 초안을 업로드한 날짜가 접수일로 기록됩니다.",

      번역문초안발명자검토:
        "번역문 초안에 대한 발명자의 검토 기한을 표시합니다. 이는 법적 기한이 아닌 회사 내부 업무 처리 기한입니다. 발명자 검토 파일을 업로드하거나 다운로드할 수 있습니다.",

      번역문초안발명자검토일:
        "번역문 초안에 대한 발명자의 검토 기한을 표시합니다. 이는 법적 기한이 아닌 회사 내부 업무 처리 기한입니다. 발명자 검토 파일을 업로드하거나 다운로드할 수 있습니다.",

      번역문초안담당자검토:
        "번역문 초안에 대한 담당자의 검토 기한을 표시합니다. 이는 법적 기한이 아닌 회사 내부 업무 처리 기한입니다. 담당자 검토 파일을 업로드하거나 다운로드할 수 있습니다.",

      번역문초안담당자검토일:
        "번역문 초안에 대한 담당자의 검토 기한을 표시합니다. 이는 법적 기한이 아닌 회사 내부 업무 처리 기한입니다. 담당자 검토 파일을 업로드하거나 다운로드할 수 있습니다.",

      번역문초안수정본전달:
        "대리인에게 전달할 번역문 초안 검토 의견을 업로드합니다. 대리인은 의견을 확인해 번역문 초안을 수정한 후 수정본을 업로드합니다. 수정본 파일을 업로드하거나 다운로드할 수 있으며, 대리인이 수정본을 업로드한 날짜가 접수일로 기록됩니다.",

      번역문초안수정본전달일:
        "대리인에게 전달할 번역문 초안 검토 의견을 업로드합니다. 대리인은 의견을 확인해 번역문 초안을 수정한 후 수정본을 업로드합니다. 수정본 파일을 업로드하거나 다운로드할 수 있으며, 대리인이 수정본을 업로드한 날짜가 접수일로 기록됩니다.",

      번역문초안최종본접수:
        "번역문 초안 최종본의 접수일을 표시하며, 최종본 파일을 업로드하거나 다운로드할 수 있습니다. 대리인이 최종본을 업로드한 날짜가 접수일로 기록됩니다.",

      번역문초안최종본접수일:
        "번역문 초안 최종본의 접수일을 표시하며, 최종본 파일을 업로드하거나 다운로드할 수 있습니다. 대리인이 최종본을 업로드한 날짜가 접수일로 기록됩니다.",

      번역문기한: "번역문 제출 기한을 표시합니다.",

      국제조사보고서:
        "PCT 국제조사보고서를 업로드하거나 다운로드할 수 있습니다. 국제조사보고서는 각 국가의 심사 단계에서 참고자료로 활용되지만, 법적 구속력은 없습니다.",

      국내단계진입기한:
        "PCT 국제출원의 국내단계 진입 기한을 표시합니다. 국내단계에 진입한 후에는 해당 국가의 출원 심사 절차가 진행됩니다.",

      PACE신청일:
        "PACE 신청일을 표시합니다. PACE는 유럽특허청의 심사 절차를 신속하게 진행하기 위한 제도로, 신청하면 일반적인 경우보다 빠르게 등록 여부를 심사받을 수 있습니다.",

      지정국가:
        "유럽특허청에서 등록이 결정되면 특허권을 확보할 국가를 지정합니다. 지정한 국가별로 등록료를 납부해야 해당 국가에서 특허권을 인정받을 수 있습니다.",

      지정국번역문초안작성지시:
        "지정국 번역문 초안 작성을 지시합니다. 버튼을 누르면 지시가 전달되고 지시일이 표시됩니다. 지시일은 직접 변경할 수 없습니다.",

      지정국번역문초안작성지시일:
        "지정국 번역문 초안 작성을 지시합니다. 버튼을 누르면 지시가 전달되고 지시일이 표시됩니다. 지시일은 직접 변경할 수 없습니다.",

      번역문초안수정본접수:
        "대리인에게 전달할 번역문 초안 검토 의견을 업로드합니다. 대리인은 의견을 확인해 번역문 초안을 수정한 후 수정본을 업로드합니다. 수정본 파일을 업로드하거나 다운로드할 수 있으며, 대리인이 수정본을 업로드한 날짜가 접수일로 기록됩니다.",

      번역문초안수정본접수일:
        "대리인에게 전달할 번역문 초안 검토 의견을 업로드합니다. 대리인은 의견을 확인해 번역문 초안을 수정한 후 수정본을 업로드합니다. 수정본 파일을 업로드하거나 다운로드할 수 있으며, 대리인이 수정본을 업로드한 날짜가 접수일로 기록됩니다.",

      지정국번역문기한: "지정국 번역문 제출 기한을 표시합니다.",
    };
    return data[str] || "";
  },

  convertProductStateCodeToState(code) {
    switch (Number(code)) {
      case 0:
        return "미적용";
      case 1:
        return "제품 개발중";
      case 2:
        return "제품 적용중";
      default:
        return "알 수 없음";
    }
  },

  numberWithCommas(x) {
    // 유효성 체크 추가
    if (x == null || isNaN(x)) {
      return "0";
    }

    // 금액 잔차만 정리 (환율·퍼센트 등 정상 소수는 유지)
    const cleaned = sanitizeFloatDisplay(Number(x));
    return cleaned
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  },

  /** KRW 등 금액 전용 — 항상 소수 2자리로 정규화 후 콤마 */
  commaifyMoney(value) {
    return this.commaify(money2(value));
  },

  numberWithCommasMoney(x) {
    if (x == null || isNaN(x)) return "0";
    return money2(x)
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  },

  calcGraphMaxNumber(arr) {
    let max = Math.floor(Math.max.apply(null, arr) * 1.3);

    let max_str = max + "";
    let cnt = max_str.length - 1;
    let divide_num = 1;

    for (let i = 0; i < cnt; i++) {
      divide_num += "0";
    }
    divide_num = Number(divide_num);
    max = Math.ceil(max / divide_num) * divide_num;

    return max;
  },

  convertInvestTypeToStr(code) {
    switch (code) {
      case 0:
        return "개인형 엑셀러레이터";
      case 1:
        return "법인형 엑셀러레이터";
      case 2:
        return "벤쳐캐피탈";
      case 3:
        return "사모펀드";
      case 4:
        return "은행";
      case 5:
        return "개인투자조합";
      case 6:
        return "기술지주회사";
      case 7:
        return "기업";
    }
  },

  notTd(colSpan, str) {
    return (
      <tr className="not_styled">
        <td colSpan={Math.max(Number(colSpan) || 1, 1)}>
          <span className="not_styled_label">{str}</span>
        </td>
      </tr>
    );
  },

  convertAuthCodeToStr(rank) {
    let authName = "";
    switch (rank) {
      case 0:
        authName = "경영진";
        break;
      case 1:
        authName = "관리자";
        break;
      case 2:
        authName = "발명자";
        break;
      case 9:
        authName = "회사계정";
        break;
      case 10:
        authName = "대표";
        break;
      case 11:
        authName = "관리자";
        break;
      case 12:
        authName = "담당자";
        break;
      case 19:
        authName = "회사계정";
        break;
      case 29:
        authName = "투자자";
        break;
    }
    return authName;
  },

  convertBillTypeToStr(n) {
    let authName = "";
    switch (n) {
      case 0:
        authName = "출원 전";
        break;
      case 1:
        authName = "원출원";
        break;
      case 2:
        authName = "분할출원";
        break;
      case 3:
        authName = "변경출원";
        break;
      case 4:
        authName = "가출원";
        break;
      case 5:
        authName = "심사청구";
        break;
      case 6:
        authName = "우선 심사청구";
        break;
      case 7:
        authName = "중간사건";
        break;
      case 8:
        authName = "자진보정";
        break;
      case 9:
        authName = "기간연장";
        break;
      case 10:
        authName = "OA대응";
        break;
      case 11:
        authName = "등록";
        break;
      case 12:
        authName = "심판 청구";
        break;
      case 13:
        authName = "심판 중간 (의견서 제출)";
        break;
      case 14:
        authName = "심판 중간 (답변서 제출)";
        break;
      case 15:
        authName = "심판 성사";
        break;
      case 16:
        authName = "연차료 관리";
        break;
      case 17:
        authName = "명의 변경 및 실시권 설정 등록";
        break;
      case 18:
        authName = "정보변경";
        break;
      case 19:
        authName = "기타 분석 업무";
        break;
      case 20:
        authName = "그외 업무(기타)";
        break;
      case 21:
        authName = "선행기술조사";
        break;
      case 22:
        authName = "일반 출원";
        break;
      case 23:
        authName = "심사청구";
        break;
      case 24:
        authName = "우선심사신청";
        break;
      case 25:
        authName = "계속출원";
        break;
      case 26:
        authName = "분할출원";
        break;
      case 27:
        authName = "재출원";
        break;
      case 28:
        authName = "EP 개별국 출원";
        break;
      case 29:
        authName = "oa";
        break;
      case 30:
        authName = "출원 유지";
        break;
      case 31:
        authName = "IDS";
        break;
      case 32:
        authName = "자진보정";
        break;
      case 33:
        authName = "등록";
        break;
      case 34:
        authName = "기타비용\n(정보변경, 통지서 송부 등)";
        break;
      case 35:
        authName = "기타비용\n(클레임차트 작성, 분석비용)";
        break;
      case 36:
        authName = "선행기술 조사";
        break;
      case 37:
        authName = "국제단계";
        break;
      case 38:
        authName = "국내단계";
        break;
    }
    return authName;
  },

  convertTechGradeToNumber(techGrade) {
    const techGradeArr = [
      "N",
      "E",
      "D-",
      "D",
      "D+",
      "C-",
      "C",
      "C+",
      "B-",
      "B",
      "B+",
      "A-",
      "A",
      "A+",
      "S-",
      "S",
      "S+",
      "SS",
    ];
    let number =
      ((techGradeArr.indexOf(techGrade) + 1) / techGradeArr.length) * 10;

    return number.toFixed(1);
  },

  commaify(value) {
    // IEEE 잔차만 정리 — 환율·건수·정상 소수는 유지
    value = sanitizeFloatDisplay(value);
    let result = ("" + value).replace(/^(-?\d+)(\d{3})/, "$1,$2");
    return value == result ? result : this.commaify(result);
  },

  newCommaify(value) {
    value = value.toString().replace(/\D/g, "");
    let result = ("" + value).replace(/^(-?\d+)(\d{3})/, "$1,$2");
    return value == result ? result : this.commaify(result);
  },

  removeHTML(str) {
    let text = str.replace(/<br\/>/gi, "\n");
    text = text.replace(
      /<(\/)?([a-zA-Z]*)(\s[a-zA-Z]*=[^>]*)?(\s)*(\/)?>/gi,
      ""
    );
    return text;
  },

  deduplicationToJSON(arr, c) {
    return arr.filter((item1, idx1) => {
      return (
        arr.findIndex((item2) => {
          return item1[c ? c : "idx"] === item2[c ? c : "idx"];
        }) === idx1
      );
    });
  },

  decode(str) {
    const entities = {
      amp: "&",
      apos: "'",
      lt: "<",
      gt: ">",
      quot: '"',
      nbsp: "\xa0",
    };
    const entityPattern = /&([a-z]+);/gi;

    return str.replace(entityPattern, (match, entity) => {
      entity = entity.toLowerCase();
      if (entities.hasOwnProperty(entity)) {
        return entities[entity];
      }
      return match;
    });
  },

  logout(mode) {
    this.deleteSession();
    let { Kakao } = window;
    Kakao.Auth.logout();
    window.location.href = qs.parse(window.location.search)?.code == "HJESB7" || sessionStorage.getItem("code") == "HJESB7" ? "/login" : "/";
  },
  copy(el) {
    el = el.current;
    el.select();
    document.execCommand("copy");
    el.setSelectionRange(0, 0); //선택영역 초기화
    window.$Global.toast("클립보드에 복사되었습니다");
  },

  /** 교차 출처 IPMS iframe 등 — 목록 조건 sessionStorage 정리 요청 */
  notifyIframesLogout() {
    try {
      const frames = document.querySelectorAll("iframe");
      frames.forEach((frame) => {
        try {
          frame.contentWindow?.postMessage({ type: "ipms:logout" }, "*");
        } catch (_) {
          /* ignore */
        }
      });
    } catch (_) {
      /* ignore */
    }
  },

  deleteSession() {
    const code = sessionStorage.getItem("code");
    this.notifyIframesLogout();
    sessionStorage.clear();
    if (code) {
      sessionStorage.setItem("code", code);
    }
  },

  dataURItoBlob(dataURI) {
    let byteString = atob(dataURI.split(",")[1]);
    let mimeString = dataURI.split(",")[0].split(":")[1].split(";")[0];
    let ab = new ArrayBuffer(byteString.length);
    let ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([ab], { type: mimeString });
  },

  getBrowserSize() {
    return {
      width: window.innerWidth,
      height: window.innerHeight,
    };
  },

  getDday(expiration_at) {
    let today = new Date().getTime();
    let gap = expiration_at - today;
    let dday = Math.ceil(gap / (1000 * 60 * 60 * 24));
    return dday < 0 ? "종료" : dday;
  },

  getFullDday(expiration_at) {
    let today = new Date().getTime();
    let gap = expiration_at - today;
    let dday = Math.ceil(gap / (1000 * 60 * 60 * 24));
    return dday < 0 ? "종료" : `(D-${dday})`;
  },
  calcYear(start_year, cnt) {
    const year = Number(start_year.toString().substr(2));
    let convert_arr = [year + "년"];
    let year_arr = [start_year];
    for (let i = 1; i <= cnt; i++) {
      convert_arr.push(year + i + "년");
      year_arr.push(start_year + i);
    }
    return { convert_arr: convert_arr, year_arr: year_arr };
  },

  numberFormat(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  },

  numberToKorean(number) {
    let inputNumber = number < 0 ? false : number;
    let unitWords = ["", "만 ", "억 ", "조 ", "경 "];
    let splitUnit = 10000;
    let splitCount = unitWords.length;
    let resultArray = [];
    let resultString = "";

    for (let i = 0; i < splitCount; i++) {
      let unitResult =
        (inputNumber % Math.pow(splitUnit, i + 1)) / Math.pow(splitUnit, i);
      unitResult = Math.floor(unitResult);
      if (unitResult > 0) {
        resultArray[i] = unitResult;
      }
    }

    for (let i = 0; i < resultArray.length; i++) {
      if (!resultArray[i]) continue;
      resultString =
        String(this.numberFormat(resultArray[i])) + unitWords[i] + resultString;
    }

    return resultString;
  },

  numberRegx(str) {
    let regexp = /[^0-9]/g;

    if (str[0] == 0) {
      str = str.substring(1);
    }
    return str.replace(regexp, "");
  },

  isNumberInput(str) {
    return str.replace(/[^0-9]/g, "");
  },

  matchJsonToStr(json, key, condition) {
    if (this.isEmptyObject(json)) return;
    let result = [];
    let obj = json[key];
    let keys = Object.keys(obj);
    let values = Object.values(obj);

    for (
      let i = 0;
      i <= Math.ceil(Math.sqrt(Math.max.apply(null, values)));
      i++
    ) {
      let square = condition & Math.pow(2, i);
      if (square !== 0) {
        for (let j in keys) {
          if (obj[keys[j]] == square) {
            result.push(keys[j]);
          }
        }
      }
    }

    return result.join(", ");
  },

  matchJsonToValue(json, condition) {
    if (this.isEmptyObject(json)) return;

    let result = [];
    let keys = Object.keys(json);

    for (let i = 0; i < keys.length; i++) {
      let square = condition & Math.pow(2, i);

      if (square !== 0) {
        for (let j in keys) {
          if (json[keys[j]] == square) {
            result.push(square);
          }
        }
      }
    }
    return result;
  },

  setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    let expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  },

  getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  },

  convertLine(str) {
    var re = /\r\n/g;
    return str.replaceAll(re, "<br/>");
  },

  extendCheckImage(str) {
    if (!str.match(config.imgTypeCheck)) {
      alert("jpg, jpeg, png, gif, 파일만 업로드 가능합니다.");
      return false;
    }
    return true;
  },

  extendCheckPDF(str) {
    if (!str.match(config.pdfTypeCheck)) {
      alert("PDF 파일만 업로드 가능합니다.");
      return false;
    }
    return true;
  },

  imagePopup(url) {
    var imgObj = new Image();
    imgObj.src = url;
    let imageWin = window.open(
      "",
      "profile_popup",
      "width=" + imgObj.width + "px, height=" + imgObj.height + "px"
    );
    imageWin.document.write("<html><body style='margin:0'>");
    imageWin.document.write(
      "<a href=javascript:window.close()><img src='" +
        imgObj.src +
        "' border=0></a>"
    );
    imageWin.document.write("</body><html>");
    imageWin.document.title = imgObj.src;
  },

  addressSearch(address) {
    // 주소-좌표 변환 객체를 생성합니다
    let geocoder = new kakao.maps.services.Geocoder();

    // 주소로 좌표를 검색합니다
    return new Promise((resolve, reject) => {
      if (!address) {
        return resolve({});
      } else {
        geocoder.addressSearch(address, (result, status) => {
          // 정상적으로 검색이 완료됐으면
          if (status === kakao.maps.services.Status.OK) {
            resolve({
              lon: result[0].x,
              lat: result[0].y,
            });
          } else {
            alert("주소를 다시 확인해주세요");
            reject("NO DATA");
          }
        });
      }
    });
  },

  blockRightClick(e) {
    e.preventDefault();
    alert("오른쪽 버튼은 사용할 수 없습니다.");
    return false;
  },

  toggleViewType() {
    const token = window.$Global.getToken();
    let ipnowUrl = "https://ipnow.co.kr";
    let findBizUrl = "https://biznavi.co.kr";

    if (token !== null) {
      ipnowUrl += "?token=" + token;
      findBizUrl += "?token=" + token;
    }

    const url =
      window.location.hostname.indexOf("findbiz") > -1 ? ipnowUrl : findBizUrl;
    window.open(url, "_blank");
  },

  getToken() {
    return sessionStorage.getItem(config.keyToken);
  },

  hasLoginToken() {
    return this.getToken() != null;
  },

  saveHistory() {
    const auth = this.hasLoginToken();
    if (!auth) {
      sessionStorage.setItem("historyURL", window.location.href);
    }
  },

  renderFunc(props, Component) {
    const auth = this.hasLoginToken();
    window.$Global.saveHistory();
    return auth ? <Component {...props} /> : <Redirect to="/login" />;
  },

  toast(msg) {
    // react-toastify v6에는 기본 아이콘이 없어 직접 뱃지를 넣는다.
    toast.success(
      <div className="ipnow-toast-content">
        <span className="ipnow-toast-badge" aria-hidden="true">
          <svg viewBox="0 0 24 24" width="14" height="14" focusable="false">
            <path
              d="M9.2 16.2L5.5 12.5l1.4-1.4 2.3 2.3 6.1-6.1 1.4 1.4-7.5 7.5z"
              fill="currentColor"
            />
          </svg>
        </span>
        <span className="ipnow-toast-text">{msg}</span>
      </div>,
      {
        position: "top-center",
        autoClose: 2200,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        progress: undefined,
        transition: Slide,
        className: "ipnow-toast",
        bodyClassName: "ipnow-toast-body",
      }
    );
  },

  saveToast() {
    this.toast("저장되었습니다");
  },
  registerToast() {
    this.toast("등록되었습니다");
  },
  updateToast() {
    this.toast("수정을 눌러 편집 해주세요");
  },
  confirmToast() {
    this.toast("이벤트를 클릭하시면 읽음처리 됩니다");
  },

  handleCopyImage(imageUrl) {
    if (!imageUrl) return;

    const writeBlob = (blob) => {
      if (!blob) {
        alert("이미지 복사에 실패했습니다.");
        return;
      }
      Clipboard.write([
        new ClipboardItem({ [blob.type || "image/png"]: blob }),
      ]).catch(() => {
        alert("클립보드 복사에 실패했습니다.");
      });
    };

    // CDN 이미지는 CORS 없이 canvas에 그리면 tainted → toBlob 실패
    const copyViaCanvas = () =>
      new Promise((resolve, reject) => {
        const img = new Image();
        img.crossOrigin = "anonymous";
        img.onload = () => {
          try {
            const canvas = document.createElement("canvas");
            canvas.width = img.naturalWidth || img.width;
            canvas.height = img.naturalHeight || img.height;
            canvas.getContext("2d").drawImage(img, 0, 0);
            canvas.toBlob((blob) => {
              if (!blob) {
                reject(new Error("toBlob failed"));
                return;
              }
              writeBlob(blob);
              resolve();
            }, "image/png");
          } catch (err) {
            reject(err);
          }
        };
        img.onerror = () => reject(new Error("image load failed"));
        img.src = imageUrl;
      });

    const copyViaFetch = () =>
      fetch(imageUrl, { mode: "cors", credentials: "omit" })
        .then((res) => {
          if (!res.ok) throw new Error("fetch failed");
          return res.blob();
        })
        .then(writeBlob);

    copyViaCanvas().catch(() =>
      copyViaFetch().catch(() => {
        alert(
          "이미지 복사에 실패했습니다. (CDN CORS 설정을 확인해 주세요)"
        );
      })
    );
  },

  convertStateName(state, termination_type) {
    let str = "";
    switch (state) {
      case 0:
        str = "준비";
        break;
      case 4:
        str = "출원";
        break;
      case 80:
        str = "공고";
        break;
      case 98:
        str = "거절(미확정)";
        break;
      case 7:
        str = "등록";
        break;
      case 8:
        str = "OA";
        break;
      case 99:
        if (termination_type === 3) {
          str = "거절(확정)";
        } else if (termination_type === 4) {
          str = "소멸";
        } else if (termination_type === 2) {
          str = "포기";
        } else if (termination_type === 1) {
          str = "취하";
        } else if (termination_type === 0) {
          str = "무효";
        }
        break;
    }
    return str;
  },

  convertCountryName(name) {
    if (!name) return "";
    
    const obj = tradeMarkCountryKr.find((item) => {
      const key = Object.keys(item)[0];
      return key === name;
    });

    if (!obj) return "";
    
    return Object.values(obj)[0] || "";
  },

  convertNationName(value) {
    return tradeMarkNationKr[value];
  },
  /** asset paid 리스트 payment_state_name 과 동일 매핑 */
  convertPayStateTypeToStr(n) {
    switch (Number(n)) {
      case 0:
        return "대기";
      case 1:
        return "납부요청";
      case 2:
      case 3:
        return "납부완료";
      // case 3:
      //   return "입금요청";
      case 4:
        return "입금완료";
      case 5:
        return "기업체납부";
      case 6:
        return "납부제외";
      case 99:
        return "포기";
      default:
        return "";
    }
  },

  /** AnnualFeeList PaymentState 폰트 색상과 동일 매핑 */
  getPaymentStateLabelClassName(n) {
    switch (Number(n)) {
      case 0:
      case 1:
      case 2:
        return "payment_cell_label--pending";
      case 3:
        return "payment_cell_label--paid-complete";
      case 4:
        return "payment_cell_label--deposit-request";
      case 5:
        return "payment_cell_label--company";
      case 6:
        return "payment_cell_label--excluded";
      case 99:
        return "payment_cell_label--giveup";
      default:
        return "payment_cell_label--pending";
    }
  },

  validateBirthDate(date) {
    if (date === null || date === undefined || date === "") return false;
    const raw = String(date).trim();
    // YYYY-MM-DD 또는 YYYYMMDD
    let compact = raw;
    if (/^\d{4}-\d{2}-\d{2}$/.test(raw)) {
      compact = raw.replace(/-/g, "");
    }
    const pattern =
      /^(19[0-9][0-9]|20\d{2})(0[0-9]|1[0-2])(0[1-9]|[1-2][0-9]|3[0-1])$/;
    if (!pattern.test(compact)) return false;
    const y = Number(compact.slice(0, 4));
    const m = Number(compact.slice(4, 6));
    const d = Number(compact.slice(6, 8));
    const dt = new Date(y, m - 1, d);
    return (
      dt.getFullYear() === y && dt.getMonth() === m - 1 && dt.getDate() === d
    );
  },

  validateEmailAddress(address) {
    const pattern = /^[A-Za-z0-9_\.\-]+@[A-Za-z0-9\-]+\.[A-za-z0-9\-]+/;

    if (pattern.test(address) === false) {
      return false;
    } else {
      return true;
    }
  },

  getOrdinalNumber(number) {
    const specialCases = ["th", "st", "nd", "rd"],
      v = number % 100;
    return (
      number +
      (specialCases[(v - 20) % 10] || specialCases[v] || specialCases[0])
    );
  },
};
